import { render } from "./ContactsManagement.vue?vue&type=template&id=c61727ac&scoped=true"
import script from "./ContactsManagement.vue?vue&type=script&lang=js"
export * from "./ContactsManagement.vue?vue&type=script&lang=js"

import "./ContactsManagement.vue?vue&type=style&index=0&id=c61727ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61727ac"]])

export default __exports__